import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererParams } from '@ag-grid-community/core';

import { ToggleRenderer } from './toggle-renderer';

@Component({
    selector: 'entity-slide-toggle-renderer',
    template: `
        <p-slide-toggle
            class="slide-toggle-renderer"
            (toggleChanged)="onToggleChanged($event)"
            [checked]="checked"
            [disabled]="disable"
            [labelOff]="labelOff"
            [labelOn]="labelOn"
        >
        </p-slide-toggle>
    `,
    styleUrls: ['./slide-toggle-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SlideToggleRendererComponent<RowData> implements ToggleRenderer<RowData> {
    public labelOn?: string;
    public labelOff?: string;
    public checked = false;
    public disable = false;
    public toggleChanged?: (value: boolean, rowData: RowData) => void;
    private setValue?: (value: boolean) => void;
    private rowData?: RowData;

    agInit(params: ICellRendererParams): void {
        const inputData = params?.colDef?.cellRendererParams;
        this.setValue = params.setValue;
        this.rowData = params.data;
        if (inputData) {
            this.checked = inputData.getValue(params);
            this.labelOn = inputData.labelOn;
            this.labelOff = inputData.labelOff;
            this.disable = inputData.disabled;
            this.toggleChanged = inputData.toggleChanged;
        }
    }

    public onToggleChanged(value: boolean): void {
        if (this.setValue) this.setValue(value);
        if (this.rowData) this.toggleChanged?.(value, this.rowData);
    }

    public refresh(params: ICellRendererParams): boolean {
        return false;
    }
}
